module.exports = __webpack_public_path__ + "static/media/thubnail.09e6c5c8.png";